export const dragdropFix = () => {
  const draggableID = 'draggable';
  const draggableElement = document.getElementById(draggableID);
  if (!draggableElement) {
    const draggableDiv = document.createElement('div');
    draggableDiv.setAttribute('id', draggableID);
    draggableDiv.setAttribute('data-left', '0');
    draggableDiv.setAttribute('data-top', '0');
    draggableDiv.style.display = 'none';
    document.body.appendChild(draggableDiv);
  }

  const droppableElements = document.querySelectorAll(
    '.drag-and-drop-wrapper .answer-wrapper .droppable',
  );

  if (droppableElements) {
    for (let i = 0; i < droppableElements.length; i += 1) {
      const element = droppableElements[i] as HTMLElement;
      element.style.position = 'relative';
    }
  }
};
